module.exports = __webpack_public_path__ + "static/media/activities.85a16477.svg";